/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCompanyDtoPublicSiteMenuItemDto
 */
export interface WebApiCompanyDtoPublicSiteMenuItemDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCompanyDtoPublicSiteMenuItemDto
     */
    customListId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoPublicSiteMenuItemDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the WebApiCompanyDtoPublicSiteMenuItemDto interface.
 */
export function instanceOfWebApiCompanyDtoPublicSiteMenuItemDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCompanyDtoPublicSiteMenuItemDtoFromJSON(json: any): WebApiCompanyDtoPublicSiteMenuItemDto {
    return WebApiCompanyDtoPublicSiteMenuItemDtoFromJSONTyped(json, false);
}

export function WebApiCompanyDtoPublicSiteMenuItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCompanyDtoPublicSiteMenuItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WebApiCompanyDtoPublicSiteMenuItemDtoToJSON(value?: WebApiCompanyDtoPublicSiteMenuItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customListId': value.customListId,
        'name': value.name,
    };
}

